<template>
  <b-modal v-model="showModal" title="LICENSE ACTIVATION" size="lg">
    <strong>You are currently using the free version of 3DPrinterOS.</strong>
    <p>
      Uploading-preparing-slicing and printing are free and will always be free for personal and corporate use within our Fair Usage Policy.
      To access our Premium and Organizational features please <a href="http://www.3dprinteros.com/premium-license" target="_blank">upgrade your account</a>.
    </p>
    <br/>
    <b-form-group
        label-for="license-input"
        label="Already upgraded? Enter your license key here:"
        :state="formState"
        :invalidFeedback="error">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" id="license-key-prefix">3DPrinterOS - </span>
        </div>
        <b-form-input id="license-input" v-model="code" class="inp" placeholder="XXXX-XXXX-XXXX-XXXX" aria-discribedby="license-key-prefix"></b-form-input>
      </div>
    </b-form-group>
    <template v-slot:modal-footer="{ cancel }">
      <div class="modal__footer--left">
        <b-button variant="-gray" :disabled="processing" @click="cancel()">
          Not now
        </b-button>
      </div>
      <div class="modal__footer--right">
        <b-button variant="-primary" :disabled="processing" @click="handleActivate">
          Activate now
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'license-activation-modal',
    data() {
      return {
        showModal: false,
        code: '',
        processing: false,
        error: null
      }
    },
    computed: {
      formState() {
        return !(this.error && this.error.trim());
      }
    },
    methods: {
      ...mapActions(['upgradeLicense']),

      handleActivate() {
        this.error = '';
        this.processing = true;
        this.upgradeLicense(this.code).then(({data}) => {
          this.processing = false;
          if (data.result) {
            this.showModal = false;
            window.location.reload();
          } else {
            this.error = data.message;
          }
        })
      },

      open() {
        this.showModal = true;
      }
    }
  }
</script>